import axios from 'axios/index';


function getQuestionStats(questionId, questId, okCallback, koCallback){
    return axios.post('/quests/stats/' + questionId + '?questId=' + questId,{filtersWithAgeGroup:{filters:[]}})
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}


export default {
    getQuestionStats
};



